import { render, staticRenderFns } from "./UpsertPageWithTabs.vue?vue&type=template&id=4c006054&scoped=true&lang=pug&"
import script from "./UpsertPageWithTabs.vue?vue&type=script&lang=js&"
export * from "./UpsertPageWithTabs.vue?vue&type=script&lang=js&"
import style0 from "./UpsertPageWithTabs.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./UpsertPageWithTabs.vue?vue&type=style&index=1&id=4c006054&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c006054",
  null
  
)

export default component.exports